import type { TestAccountType } from '@prisma/client';

export const getLogInPrompt = (account: { userName: string; password: string; type: TestAccountType }) => {
  return account.type === 'GOOGLE' ?
      `Sign in using Google OAuth and the Google Account ${account.userName}. If attempts to take screenshots fail repeatedly, manually switch back to the original tab`
    : `Wait for 1 second, and log in with ${account.userName} and password ${account.password}`;
};
